import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { GridModalData } from '@app/core/components/grid/modals/grid-modal.service';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ProductsConfigParams } from '@app/views/components/products-config/products-config.component';
import { SelectLineProductsParams } from '@app/views/components/select-line-products/select-line-products.component';

@GridModalComponent('MultipleProductsConfigDialogTs')
@Component({
    selector: 'tt-multiple-products-config-dialog',
    templateUrl: './multiple-products-config-dialog.component.html',
    styleUrls: ['./multiple-products-config-dialog.component.css'],
})
export class MultipleProductsConfigDialogComponent {
    get?: MultipleProductsConfigGet;

    selectProductsParams?: SelectLineProductsParams;

    productsConfigParams?: ProductsConfigParams;

    constructor(@Inject(MAT_DIALOG_DATA) private data: GridModalData, private dialogRef: MatDialogRef<MultipleProductsConfigDialogComponent>, private datatask: DataTaskService) {
        console.log(data);
        this.dialogRef.updateSize('min(85rem, 90vw)', '95vh');
        let parameters: any;
        if (!!data.loadData?.parameters) {
            if (data.loadData.parameters instanceof Function) {
                parameters = data.loadData.parameters();
            } else {
                parameters = data.loadData.parameters;
            }

            if (parameters instanceof Promise) {
                // parameters = await parameters;
            }

            if ('order_internal_no' in parameters) {
                parameters = { argtype: 'orderline', headno: +(parameters.order_internal_no as number), lineno: 0 };
                // this.get!.argtype = 'orderline';
                // this.get!.headno = +(data.loadData.parameters.order_internal_no as number);
            } else if ('purch_internal_no' in parameters) {
                parameters = { argtype: 'purchline', headno: +(parameters.purch_internal_no as number), lineno: 0 };
                // this.get!.argtype = 'purchline';
                // this.get!.headno = +(data.loadData.parameters.purch_internal_no as number);
            }
        }

        this.loadGet(parameters);

        // if (this.get!.show_models_tab === '0') {
        //     this.get!.selected_item_id = '-';
        //     this.get!.selected_tab = 'SELECTPRODUCTS';
        // }
    }

    private async loadGet(params: { argtype: string; headno: string | number; lineno: string | number }) {
        this.get = (await this.datatask.Post(3847, params))[0];

        if (this.get?.show_models_tab === '0') {
            this.selectProductsParams = this.get;
        }
    }

    onModelSubmit(event: SelectLineProductsParams) {
        this.selectProductsParams = event;

        setTimeout(() => {
            this.get!.selected_tab = 'SELECTPRODUCTS';
        });
    }

    onProductsSubmit(event: ProductsConfigParams) {
        this.productsConfigParams = event;

        setTimeout(() => {
            this.get!.selected_tab = 'PRODUCTSCONFIG';
        });
    }

    onConfigurationSubmit() {
        this.dialogRef.close();
    }
}

export interface MultipleProductsConfigGet extends SelectLineProductsParams {
    show_models_tab: '1' | '0';
    selected_tab: string;
}
